import Model, {
  attr,
  hasMany,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';
import type Milestone from 'linced-admin/models/milestones/milestone';

// Proto: milestones.MilestoneSetTemplate.
export default class MilestoneSet extends Model {
  declare [Type]: 'milestones/milestone-set';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('boolean', { defaultValue: false })
  declare isPublished: boolean;

  @hasMany('milestones/milestone', {
    async: true,
    inverse: 'milestoneSetTemplateId',
  })
  declare milestones: AsyncHasMany<Milestone>;
}
